import React, { useState } from 'react';
import Switch from '@applied/dragonfruit/src/components/Switch/Switch';
import type { PasswordFieldProps } from '@applied/dragonfruit/src/components/TextField/PasswordField';
import PasswordField from '@applied/dragonfruit/src/components/TextField/PasswordField';
import TextField from '@applied/dragonfruit/src/components/TextField/TextField';

type RevealablePasswordProps = PasswordFieldProps & {
  switchLabel?: string;
};

export function RevealablePassword(props: RevealablePasswordProps): JSX.Element {
  const { switchLabel, ...rest } = props;
  const [revealPassword, setRevealPassword] = useState(false);
  return (
    <>
      {revealPassword ? <TextField {...rest} /> : <PasswordField {...rest} />}
      <Switch
        label={switchLabel || 'Reveal Password'}
        selected={revealPassword}
        onChange={setRevealPassword}
      />
    </>
  );
}
